import { UPLOAD_DATE_RANGE_MAP } from 'consts/filterOptions'

import isUploadDateFunction from './isUploadDateFunction'

function getUploadDateByValue(value) {
  if (value?.startsWith('custom')) {
    const [, gte, lte] = value.split('_')
    return isUploadDateFunction({ rangeQuery: { gte: Number(gte), lte: Number(lte) } })
  }

  const rangeQuery = UPLOAD_DATE_RANGE_MAP[value]
  if (rangeQuery) return isUploadDateFunction({ rangeQuery })

  return null
}

export default getUploadDateByValue
